<template>
  <div class="basic register-entrance">
    <div class="basic-header" style="margin-bottom: 30px">
      <p>- 展位预定信息 -</p>
    </div>
    <div class="basic-title">
      <span style="color: #f00">*</span>参展意向<span style="color: #f00"
        >（请勾选参展展会）</span
      >
    </div>
    <div class="choice">
      <Row :gutter="40">
        <Col span="12" v-if="company1">
          <div
            class="choicebox"
            :class="{ active: select.indexOf(0) !== -1 }"
            @click="changeArr(0)"
          >
            <div class="select">已选择</div>
            <div class="choicebox-top" @click.stop="changeSelect(0)">
              <div class="txt1">{{ company1.name }}</div>
              <div class="txt2">
                时间：{{ company1.startTime | moment("YYYY年MM月DD")
                }}{{ company1.endTime | moment("-DD日") }}
              </div>
              <div class="txt2">地点：{{ company1.address }}</div>
            </div>
            <div class="choicebox-content">
              <div class="title" @click.stop="changeSelect(0)">请选择展区</div>
              <RadioGroup
                v-model="companyInp1.areaName"
                style="width: 100%"
                v-for="(item, index) in comArea1"
                :key="index"
              >
                <Radio :label="item.name">
                  <div class="item">
                    <div class="item-box" >{{ item.name }}</div>
                    <div class="item-box2">
                      <p>光地：{{ item.zonePrice }}元 / ㎡</p>
                      <p>标摊：{{ item.zonePcount }}元 / 个（9㎡）</p>
                    </div>
                  </div>
                </Radio>
              </RadioGroup>
            </div>
            <div class="choicebox-tool">
              <span style="color: #f00">*</span>展位类型：
              <RadioGroup v-model="companyInp1.areaType">
                <Radio label="光地"></Radio>
                <Radio label="标摊"></Radio>
              </RadioGroup>
              <span style="color: #f00; display: inline-block; margin-left: 30px">*</span
              >预定面积：
              <InputNumber
                v-model="companyInp1.showArea"
                :precision="0"
                :min="1"
                :max="9999"
                >></InputNumber
              >
              <span v-if="companyInp1.areaType === '光地'">㎡</span>
              <span v-if="companyInp1.areaType === '标摊'">㎡</span>
            </div>
          </div>
        </Col>

        <Col span="12" v-if="company2">
          <div
            class="choicebox"
            :class="{ active: select.indexOf(1) !== -1 }"
            @click="changeArr(1)"
          >
            <div class="select">已选择</div>
            <div class="choicebox-top" @click.stop="changeSelect(1)">
              <div class="txt1">
                {{ company2.name }}
              </div>
              <div class="txt2">
                时间：{{ company2.startTime | moment("YYYY年MM月DD")
                }}{{ company2.endTime | moment("-DD日") }}
              </div>
              <div class="txt2">地点：{{ company2.address }}</div>
            </div>
            <div class="choicebox-content">
              <div class="title" style="text-align: center" @click.stop="changeSelect(1)">
                请选择展区
              </div>

              <!-- @on-change="radioChange(companyInp2.areaName)" -->
              <RadioGroup
                v-model="companyInp2.areaName"
                style="width: 100%"
                v-for="(item, index) in comArea2"
                :key="index"
              >
                <Radio :label="item.name">
                  <div class="item">
                    <div class="item-box">{{ item.name }}</div>
                    <div class="item-box2">
                      <p>光地：{{ item.zonePrice }}元 / ㎡</p>
                      <p>标摊：{{ item.zonePcount }}元 / 个（9㎡）</p>
                    </div>
                  </div>
                </Radio>
              </RadioGroup>
            </div>
            <div class="choicebox-tool">
              <span style="color: #f00">*</span>展位类型：
              <RadioGroup v-model="companyInp2.areaType">
                <Radio label="光地"></Radio>
                <Radio label="标摊"></Radio>
              </RadioGroup>
              <span style="color: #f00; display: inline-block; margin-left: 30px">*</span
              >预定面积：
              <InputNumber
                :precision="0"
                v-model="companyInp2.showArea"
                :min="1"
                :max="9999"
              ></InputNumber>
              <span v-if="companyInp2.areaType === '光地'">㎡</span>
              <span v-if="companyInp2.areaType === '标摊'">㎡</span>
            </div>
          </div>
        </Col>

        <Col span="12" v-if="company3" style="margin-top: 30px">
          <div
            class="choicebox"
            :class="{ active: select.indexOf(2) !== -1 }"
            @click="changeArr(2)"
          >
            <div class="select">已选择</div>
            <div class="choicebox-top" @click.stop="changeSelect(2)">
              <div class="txt1">
                2027东盟国际焙烤展览会
              </div>
              <div class="txt2">
                时间：2027年8月26-28日
              </div>
              <div class="txt2">地点：印尼雅加达国际展览中心(JIE)</div>
            </div>
            <div class="choicebox-content">
              <div class="title" style="text-align: center" @click.stop="changeSelect(2)">
                请选择展区
              </div>

              <RadioGroup
                v-model="companyInp3.areaName"
                style="width: 100%"
                v-for="(item, index) in comArea3"
                :key="index"
              >
                <Radio :label="item.name">
                  <div class="item">
                    <div class="item-box">{{ item.name }}</div>
                    <div class="item-box2">
                      <p>光地：{{ item.zonePrice }}元 / ㎡</p>
                      <p>标摊：{{ item.zonePcount }}元 / 个（9㎡）</p>
                    </div>
                  </div>
                </Radio>
              </RadioGroup>
            </div>
            <div class="choicebox-tool">
              <span style="color: #f00">*</span>展位类型：
              <RadioGroup v-model="companyInp3.areaType">
                <Radio label="光地"></Radio>
                <Radio label="标摊"></Radio>
              </RadioGroup>
              <span style="color: #f00; display: inline-block; margin-left: 30px">*</span
              >预定面积：
              <InputNumber
                :precision="0"
                v-model="companyInp3.showArea"
                :min="1"
                :max="9999"
              ></InputNumber>
              <span v-if="companyInp3.areaType === '光地'">㎡</span>
              <span v-if="companyInp3.areaType === '标摊'">㎡</span>
            </div>
          </div>
        </Col>
      </Row>
      <div
        class="basic-title"
        style="margin-bottom: 0px; margin-top: 30px; text-align: center"
      >
        <CheckboxGroup v-model="CheckboxList" vertical>
          <Checkbox label="开通">
            <span style="color: #f00">*</span
            >开通iBakeryChina焙烤商贸云B2B线上服务（目前年费优惠价2000元，原价为5000元）</Checkbox
          >
        </CheckboxGroup>
      </div>
      <Row :gutter="40">
        <Col span="12">
          <div class="select-box">
            <div class="select-title"><span style="color: #f00">*</span>参展展品</div>
            <div class="select-content">
              <RadioGroup v-model="productName" vertical>
                <Radio
                  :label="item.name"
                  v-for="(item, index) in categoryArr"
                  :key="index"
                ></Radio>
                <Radio label="其他（注明）"
                  >其他（注明）<Input
                    v-model="other"
                    style="width: 100px"
                    class="under-btn"
                  />
                </Radio>
              </RadioGroup>
            </div>
          </div>
        </Col>
        <Col span="12">
          <div class="select-box">
            <div class="select-title">计划投放广告</div>
            <div class="select-content">
              <CheckboxGroup v-model="planAd" vertical>
                <Checkbox label="线上广告"></Checkbox>
                <Checkbox label="直播"></Checkbox>
                <Checkbox label="会刊"></Checkbox>
                <Checkbox label="观众入场证"></Checkbox>
                <Checkbox label="观众手提袋"></Checkbox>
                <Checkbox label="广场广告牌"></Checkbox>
                <Checkbox label="其他（注明）"
                  >其他（注明）<Input
                    v-model="other2"
                    style="width: 100px"
                    class="under-btn"
                  />
                </Checkbox>
              </CheckboxGroup>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <!-- <div class="handle-box">
      <Button @click="validHandle" class="handle-box-btn" type="primary">提交</Button>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "register-entrance",
  data() {
    return {
      select: [],
      company1: null,
      company2: null,
      company3: null,
      productName: "", // 参展展品
      planAd: [], // 计划广告
      CheckboxList: [],
      other: "",
      other2: "",
      companyInp1: {
        showArea: 0,
        pType: "RMB",
        areaName: "",
        areaType: "",
        exhibition: "",
      },
      companyInp2: {
        showArea: 0,
        pType: "RMB",
        areaName: "",
        areaType: "",
        exhibition: "",
      },
      companyInp3: {
        showArea: 0,
        pType: "RMB",
        areaName: "",
        areaType: "",
        exhibition: "",
      },
      area1: [],
      area2: [],
      categoryArr: [],
      single: false,
      radio: 3,
      radio2: 0,
      listAreaAll: [],
      comArea1: [],
      comArea2: [],
      comArea3: [],
    };
  },
  computed: {
    exAreasOption() {
      return {
        clientId: "21", // 2023第25届中国国际焙烤展
        languageType: "中文", // 中文|英文
      };
    },
    exAreasOption2() {
      return {
        clientId: "20", // 2022第24届中国国际焙烤展
        languageType: "中文", // 中文|英文
      };
    },
  },
  methods: {
    ...mapActions({
      getApplyCompanyGetAreas: "registerdModule/getApplyCompanyGetAreas",
      getExhibitionById: "registerdModule/getExhibitionById",
      getCategoryByGroupIdLevel: "registerdModule/getCategoryByGroupIdLevel",

      PjNameGroupGetAll: "hostSetModule/PjNameGroupGetAll2",
    }),
    async init() {
      this.getApplyCompanyGetAreasHandle(); // 获取展区
      this.getExhibitionHandle(); // 获取固定展会
      let rew = await this.getCategoryByGroupIdLevel(); // 获取固定展会
      if (rew && rew.length) {
        this.categoryArr = rew;
      }
      //console.log("getCategoryByGroupIdLevel", rew);
    },
    async getApplyCompanyGetAreasHandle() {
      let res = await this.getApplyCompanyGetAreas(this.exAreasOption);
      if (res && res.length) {
        let arr = {};
        res.forEach((c) => {
          if (!arr[c.name]) {
            arr[c.name] = {
              name: c.name,
              children: [],
            };
          } else {
            arr[c.name].children.push(c);
          }
        });
        arr = Object.values(arr);
        arr.map((e) => {
          let hasObj = {};
          e.children = e.children.reduce((total, next) => {
            const filterKey = JSON.stringify(next);
            hasObj[filterKey] ? "" : (hasObj[filterKey] = true && total.push(next));
            return total;
          }, []);
        });
        this.area1 = arr;
        //console.log("2023第25届中国国际焙烤展 1111111", arr);
      }
      let res2 = await this.getApplyCompanyGetAreas(this.exAreasOption2);
      if (res2 && res2.length) {
        let arr2 = {};
        res2.forEach((c) => {
          if (!arr2[c.name]) {
            arr2[c.name] = {
              name: c.name,
              children: [],
            };
          } else {
            arr2[c.name].children.push(c);
          }
        });
        arr2 = Object.values(arr2);
        arr2.map((e) => {
          let hasObj = {};
          e.children = e.children.reduce((total, next) => {
            const filterKey = JSON.stringify(next);
            hasObj[filterKey] ? "" : (hasObj[filterKey] = true && total.push(next));
            return total;
          }, []);
        });
        this.area2 = arr2;
      }
    },
    async getExhibitionHandle() {
      this.comArea1 = [];
      this.comArea2 = [];
      this.comArea3 = [];

      // let exhibitionId = "cc063b93-8f75-4cd0-a15d-170a6611952c";
      // 位置互换，换1和2的id
      let exhibitionId2 = "a89bf3d0-d64c-4e7b-b18c-d4f5439af26e";
      let exhibitionId = "117591e4-6ab0-4ffb-a8d4-442723c17d5a";
      let exhibitionId3 = "c221ade0-5a95-45c6-b5e0-a935348c2a5e";
      let exhibitionId4 = "32f7e210-1b4a-4727-a33a-5640114e6369"; // 旧东盟展，用于给新展会补展区数据

      let opt = {
        PageSize: 999,
        sorts: [{ "propertyName": "showIndex", "ascending": true }],
        PageIndex: 1,
        ExhibitionIds: [exhibitionId, exhibitionId2, exhibitionId3, exhibitionId4],
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "typeLanguage",
                  Value: `%中文%`,
                },
              },
            ],
          },
        },
      };

      let arr = await this.PjNameGroupGetAll(opt);
      this.listAreaAll = arr.items;
      arr.items.forEach((c) => {
        if (c.exhibitionId == exhibitionId) {
          this.comArea1.push(c);
        } else if (c.exhibitionId == exhibitionId2) {
          this.comArea2.push(c);
        } else if (c.exhibitionId == exhibitionId3) {
          this.comArea3.push(c);
        } else if (c.exhibitionId == exhibitionId4 && !this.comArea3.some(x => x.exhibitionId == exhibitionId3)) {
          // 新展会（exhibitionId3）暂无展区数据时，用旧东盟展的展区全部补齐
          this.comArea3.push(c);
        }
      });

      let res = await this.getExhibitionById(exhibitionId);
      if (res) {
        this.company1 = res;
      }
      let res2 = await this.getExhibitionById(exhibitionId2);
      if (res2) {
        this.company2 = res2;
      }
      let res3 = await this.getExhibitionById(exhibitionId3);
      if (res3) {
        this.company3 = res3;
      }
    },
    async validHandle() {
      let exhibition = []; // 选中的展会
      if (!this.select.length) {
        this.$Message.error("请选择展会");
        return Promise.resolve({ valid: false });
      }

      let arr = []; // 选中数组
      let errTxt = "";
      if (this.select.indexOf(0) !== -1) {
        exhibition.push(this.company1);
        this.companyInp1.exhibition = this.company1;
        arr.push(this.companyInp1);
      }
      if (this.select.indexOf(1) !== -1) {
        exhibition.push(this.company2);
        this.companyInp2.exhibition = this.company2;
        arr.push(this.companyInp2);
      }
      if (this.select.indexOf(2) !== -1) {
        exhibition.push(this.company3);
        this.companyInp3.exhibition = this.company3;
        arr.push(this.companyInp3);
      }
      //console.log("arr", arr);
      arr.forEach((c) => {
        if (!c.areaName) {
          errTxt = "请选择展区";
          return;
        }
        if (!c.areaType) {
          errTxt = "请选择展位类型";
          return;
        }
        if (!c.showArea) {
          errTxt = "请输入预定面积";
          return;
        } else {
          // if (c.showArea < 9 && c.areaType === '光地') {
          //     errTxt = "预定面积最少为9平米";
          // }
          // 标展限制为9或9的倍数，国内光地最低36平起订 国际光地1平米起订（英文）
          //   let res = null;
          if (c.showArea < 18 && c.areaType == "光地") {
            errTxt = "光地展位起订面积为18㎡";
            return;
          }
          if (c.showArea < 9 && c.areaType == "标摊") {
            errTxt = "标摊展位起订面积为9㎡";
            return;
          }
          // else {
          //     res = c.showArea % 9
          //     if (res != 0) {
          //         errTxt = "标摊面积最少为9或9的倍数";
          //         return;
          //     }
          // }
          return;
        }
      });
      if (!this.productName) {
        this.$Message.error("请选择参展展品");
        return Promise.resolve({ valid: false });
      }
      if (!this.CheckboxList.includes("开通")) {
        errTxt = "请选择开通iBakeryChina焙烤商贸云B2B线上服务";
      }
      if (errTxt) {
        this.$Message.error(errTxt);
        return Promise.resolve({ valid: false });
      }
      let order = null;
      if (arr[0]) {
        let showArea = arr[0].showArea;
        if (arr[0].areaType === "标摊") {
          showArea = arr[0].showArea;
        }
        order = {
          exhibitionId: arr[0].exhibition.id,
          showArea: showArea,
          pType: arr[0].pType,
          allMoney: 0,
          areaType: arr[0].areaType,
          areaName: arr[0].areaName,
          exHall: arr[0].exhibition.exHall,
          ApplyBoothOrder: {
            dePjNameGroupName: arr[0].areaName,
            thirdPartyDePjNameGroupName: this.listAreaAll.find(
              (item) => item.name == arr[0].areaName
            ).thirdPartyZoneName,
            area: showArea,
            boothType: arr[0].areaType,
            monetaryUnit: arr[0].pType,
            totalPrice: 0,
          },
        };
      }
      let order2 = null;
      if (arr[1]) {
        let showArea2 = arr[1].showArea;
        if (arr[1].areaType === "标摊") {
          showArea2 = arr[1].showArea;
        }
        order2 = {
          exhibitionId: arr[1].exhibition.id,
          showArea: showArea2,
          pType: arr[1].pType,
          allMoney: 0,
          areaType: arr[1].areaType,
          areaName: arr[1].areaName,
          exHall: arr[1].exhibition.exHall,
          ApplyBoothOrder: {
            dePjNameGroupName: arr[1].areaName,
            thirdPartyDePjNameGroupName: this.listAreaAll.find(
              (item) => item.name == arr[1].areaName
            ).thirdPartyZoneName,
            area: showArea2,
            boothType: arr[1].areaType,
            monetaryUnit: arr[1].pType,
            totalPrice: 0,
          },
        };
      }

      let order3 = null;
      if (arr[2]) {
        let showArea3 = arr[2].showArea;
        if (arr[2].areaType === "标摊") {
          showArea3 = arr[2].showArea;
        }
        order3 = {
          exhibitionId: arr[2].exhibition.id,
          showArea: showArea3,
          pType: arr[2].pType,
          allMoney: 0,
          areaType: arr[2].areaType,
          areaName: arr[2].areaName,
          exHall: arr[2].exhibition.exHall,
          ApplyBoothOrder: {
            dePjNameGroupName: arr[2].areaName,
            thirdPartyDePjNameGroupName: this.listAreaAll.find(
              (item) => item.name == arr[2].areaName
            ).thirdPartyZoneName,
            area: showArea3,
            boothType: arr[2].areaType,
            monetaryUnit: arr[2].pType,
            totalPrice: 0,
          },
        };
      }
      let productName = this.productName;
      let planAd = [...this.planAd];
      if (this.productName === "其他（注明）") {
        if (!this.other) {
          this.$Message.error("请填写参展展品的其他（注明）");
          return;
        }
      }
      if (planAd.indexOf("其他（注明）") !== -1) {
        if (!this.other2) {
          this.$Message.error("请填写计划投放广告的其他（注明）");
          return;
        }
      }
      if (this.productName === "其他（注明）") {
        productName = "其他：" + this.other || "其他";
      }
      if (planAd.indexOf("其他（注明）") !== -1) {
        let len = planAd.indexOf("其他（注明）");
        planAd[len] = this.other2 ? "其他：" + this.other2 : "其他";
      }
      let res = {
        common: {
          productName: productName || this.other,
          planAd: planAd.join(";"),
        },
        ApplyCompanyOrderNewDto: order || null,
        ApplyCompanyOrderNewDto2: order2 || null,
        ApplyCompanyOrderNewDto3: order3 || null,
        exhibition: exhibition,
      };
      //console.log("validHandle", res);

      return Promise.resolve({ valid: true, ...res });
    },

    changeArr(index) {
      if (this.select.indexOf(index) === -1) {
        this.select.push(index);
      }
    },
    changeSelect(index) {
      //console.log(this.select);
      if (this.select.indexOf(index) === -1) {
        this.select.push(index);
      } else {
        this.select.splice(this.select.indexOf(index), 1);
        if (index == 0) {
          this.companyInp1.areaName = "";
        } else if (index == 1) {
          this.companyInp2.areaName = "";
        } else if (index == 2) {
          this.companyInp3.areaName = "";
        }
      }
    },

    // 二次点击取消选择
    // radioChange(e){
    //     //console.log(e);
    //     //console.log(this.$refs['radio1'].currentValue);

    //     // this.$refs['radio1'].currentValue = true;
    // },

    radioChange(e) {
      e == this.companyInp2.areaName
        ? (this.companyInp2.areaName = "")
        : (this.companyInp2.areaName = e);
    },
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #b10042 !important;
    }

    .ivu-radio-inner:after {
      background-color: #b10042;
    }

    .ivu-switch-checked {
      border-color: #b10042;
      background-color: #b10042;
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #b10042;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-title {
    line-height: 48px;
    font-size: 18px;
    background-color: #f2f2f2;
    color: #333;
    margin-bottom: 30px;
    padding-left: 30px;

    span {
      font-size: 14px;
    }
  }
}

.choice {
  margin-bottom: 30px;
}

.choicebox {
  //min-height: 686px;
  background-color: #fff;
  border: solid 1px #e5e5e5;
  position: relative;
  cursor: pointer;
  overflow: hidden;

  &.active {
    background-color: #fdf7f9;
    border: solid 1px #b10042;

    .select {
      opacity: 1;
    }

    .choicebox-content ::v-deep {
      .ivu-radio-group-item {
        &:nth-child(odd) {
          background-color: #f5eff1;
        }
      }
    }

    .choicebox-tool {
      background-color: #f5eff1;
    }
  }

  .select {
    position: absolute;
    opacity: 0;
    text-align: center;
    top: 0;
    right: 0;
    width: 84px;
    height: 32px;
    line-height: 32px;
    background-color: #b10042;
    border-radius: 0px 0px 0px 10px;
    border: solid 1px #b10042;
    font-size: 14px;
    color: #fff;
  }

  &-top {
    padding: 30px 30px 20px;
    border-bottom: solid 1px #e5e5e5;

    .txt1 {
      font-size: 16px;
      color: #333;
      font-weight: 500;
      margin-bottom: 10px;
    }

    .txt2 {
      font-size: 14px;
      color: #666;
      margin-bottom: 8px;
    }
  }

  &-content {
    padding: 30px;

    .title {
      text-align: center;
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
    }

    .item {
      display: flex;
      align-items: center;
      flex: 1;

      &-box {
        width: 50%;
        color: #333;
      }

      &-box2 {
        width: 50%;

        p {
          font-size: 14px;
          color: #333;
          font-weight: normal;
        }
      }
    }

    ::v-deep {
      .ivu-radio-group-item {
        width: 100%;
        display: flex;
        align-items: center;
        min-height: 74px;
        padding: 15px 10px 15px 20px;

        &:nth-child(odd) {
          background-color: #f7f7f7;
        }
      }
    }
  }

  &-tool {
    height: 73px;
    background-color: #f7f7f7;
    padding-left: 24px;
    border-top: solid 1px #e5e5e5;
    display: flex;
    align-items: center;
  }
}

.select-box {
  height: 275px;
  margin-top: 30px;
  margin-bottom: 30px;

  .select-title {
    line-height: 48px;
    background-color: #f2f2f2;
    padding-left: 31px;
    font-size: 18px;
  }

  .select-content {
    padding: 30px;
    border: solid 1px #e5e5e5;
  }

  ::v-deep {
    .ivu-radio-group {
      width: 100%;
    }

    .ivu-radio-group-item {
      width: 50%;
      display: inline-block;
      margin: 0;
      margin-bottom: 20px;
    }

    .ivu-checkbox-group {
      width: 100%;
    }

    .ivu-checkbox-group-item {
      width: 50%;
      display: inline-block;
      margin: 0;
      margin-bottom: 20px;
    }
  }
}

.under-btn {
  ::v-deep {
    .ivu-input {
      position: relative;
      top: -2px;
      border: none;
      border-bottom: 1px solid #bfbfbf;
      border-radius: 0;

      &:hover,
      &:active {
        outline: none;
        box-shadow: none;
      }
    }
  }
}
</style>
